import { useState, useEffect, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import VideoPlayer from "./VideoPlayer";
import { AppContext } from "../contexts/AppContext";

const LinkPreviewCard = ({ url, handleClose, isReel = false }) => {
  const appContext = useContext(AppContext);
  const [previewData, setPreviewData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = setTimeout(fetchData, 2000);
    return () => clearTimeout(getData);
  }, [url]);

  const fetchData = async () => {
    try {
      const fetchUrl = await axiosHttp.get(`link-preview?url=${url}`);
      if (fetchUrl.status === 200) {
        let data = fetchUrl.data;
        setPreviewData(data);
        setLoading(false);
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  // const isYouTubeURL = (url) => {
  //   return url.includes("youtube.com") || url.includes("youtu.be");
  // };

  // const extractYouTubeVideoId = (url) => {
  //   const videoIdRegex =
  //     /(?:\/embed\/|\/watch\?v=|\/(?:embed\/|v\/|watch\?.*v=|youtu\.be\/|embed\/|v=))([^&?#]+)/;
  //   const match = url.match(videoIdRegex);
  //   return match ? match[1] : "";
  // };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!previewData) {
    // return <p>Failed to fetch link preview.</p>;
    return null;
  }

  const handleClick = () => {
    window.open(url, "_blank");
  };

  // if (previewData.videoId) {
  //   return (
  //     <div onClick={handleClick} style={{ cursor: "pointer" }}>
  //       <img src={previewData.videoThumbnail} alt="Video Thumbnail" />
  //     </div>
  //   );
  // }

  return (
    Object.values(previewData).some((value) => !!value) && (
      <>
        {handleClose && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleClose(url);
            }}
            className="card-close-icon"
          >
            x
          </button>
        )}
        {!isReel ? (
          <div
            style={{ cursor: "pointer", position: "relative" }}
            onClick={handleClick}
            className="link-wrap"
          >
            <div>
              {previewData.image && previewData.image !== "" && (
                <img src={previewData.image} alt="Link Preview" />
              )}
            </div>
            <div>
              {previewData.title && previewData.title !== "" && (
                <h3>{previewData.title}</h3>
              )}
              {previewData.description && previewData.description !== "" && (
                <p>{previewData.description}</p>
              )}
            </div>
          </div>
        ) : (
          <div className="reel-video-player">
            <VideoPlayer videoSrc={previewData.url} />
          </div>
        )}
      </>
    )
  );
};

export default LinkPreviewCard;
